import { createSlice } from "@reduxjs/toolkit";
import { fetchAvailableSlots } from "./operation.js";

const initialState = {
  slots: [],
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const availableSlotsSlice = createSlice({
  name: "availableSlots",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAvailableSlots.fulfilled, (state, action) => {
        state.loading = false;
        state.slots = action.payload.slots;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchAvailableSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default availableSlotsSlice.reducer;
